
import { i18nText } from '@/locales';

import {Component, Vue} from 'vue-property-decorator';
import PageTitle from '@/UI/components/common/PageTitle.vue';
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import SiteServicesForm from "@/form/Settings/site/services";
import {ServiceDetailStore} from "@/store/modules/Settings/ServiceDetail"
import {IServicesListItem} from "@/entity/services/services.types";
import {ServicesCategoryStore} from "@/store/modules/ServicesCategory";
import {IServiceDetail, IServiceDetailListItem} from "@/entity/services/serviceDetail.types";
import {RouterNameEnum} from "@/router/router.types";

@Component({
  components: {
    PageTitle, FormGroup
  }
})

export default class ServicesEdit extends Vue {
  form = new SiteServicesForm();
  modal_form: boolean = false;
  procedures_impact: string[] | null = [''];
  loading: boolean = false;
  imageUrl: string =  '';

  addProcedureImpact() {
    this.procedures_impact?.push('');
  }

  cancel() {
    this.$router.push({name: RouterNameEnum.SettingsSiteServices})
  }

  async updateService(): Promise<void> {
    /*if(this.form.service_id == null){
        await this.form.submit(ServiceDetailStore.create);
        await ServiceDetailStore.fetchData({filter: {id: parseInt(this.$route.params.id)}});
    }*/
    console.log(this.procedures_impact);
    this.form.procedure_impacts = this.procedures_impact;
    console.log(this.form.procedure_impacts);

    if (await this.form.submit(ServiceDetailStore.update)) {
      await ServiceDetailStore.fetchData({filter: {service_id: parseInt(this.$route.params.id)}});
    }
  }

  get serviceDetail(): IServiceDetailListItem | null {
    return ServiceDetailStore.service_detail;
  }

  getBase64(img: any, callback: any) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  handleImageChange(info:any) {
    if (info.file.status === 'uploading') {
      this.loading = true;
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      this.getBase64(info.file.originFileObj, (imageUrl: string) => {
        this.imageUrl = imageUrl;
        this.loading = false;
      });

      this.form.image_file = info.file.originFileObj;
    }
  }

  beforeImageUpload(file: any): boolean {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      this.$message.error(i18nText("Загружать можно JPG или PNG файлы"));
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      this.$message.error(i18nText("Изображение должно быть меньше, чем 2MB"));
    }
    return isJpgOrPng && isLt2M;
  }

  async created(): Promise<void> {
    await ServiceDetailStore.fetchData({filter: {service_id: parseInt(this.$route.params.id)}});
    this.form.setFormData(this.serviceDetail);

    if(this.serviceDetail) {
      if(this.serviceDetail.procedure_impacts?.length) {
        this.procedures_impact = this.serviceDetail.procedure_impacts;
      }
      this.imageUrl = this.serviceDetail.image ? this.serviceDetail.image.src : '';
    }
  }
}
